export default "__VITE_ASSET__c5b27286__"